import FlashLib from 'flashlib_onlyplay';
import { amountYellowFontWithoutStroke } from '../fontStyles';
import MoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';

export default class ControllerWaysPanel extends FlashLib.MovieClip {
  constructor(data, $displayData) {
    super(data, $displayData);
    this.init();
    this.reset();
    this.addListeners();
  }

  init() {
    this.amountText = this.getChildByName('amount');
    this.amountText.style = { ...this.amountText.style, ...amountYellowFontWithoutStroke };
  }

  set amount(value) {
    this._amount = value;
    this.amountText.text = this._amount === 0 ? '' : MoneyFormat.formatCurrency(this._amount, 0);
  }

  get amount () {
    return this._amount;
  }

  addListeners() {
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onGameResized,
      this
    );
  }

  onGameResized(data) {
    this.goToFrame(data.isLandscape ? 1 : 2);
    this.init();
    this.amount = this.amount;
  }

  reset() {
    this.amount = 0;
  }

  multiply(multiplayer) {
    this.amount = this.amount === 0 ? multiplayer : this.amount * multiplayer;
  }
}
